<template>
	<div>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-air-baloon" title="nc-air-baloon"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-album-2" title="nc-album-2"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-alert-circle-i" title="nc-alert-circle-i"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-align-center" title="nc-align-center"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-align-left-2" title="nc-align-left-2"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-ambulance" title="nc-ambulance"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-app" title="nc-app"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-atom" title="nc-atom"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-badge" title="nc-badge"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-bag-16" title="nc-bag-16"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-bank" title="nc-bank"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-basket" title="nc-basket"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-bell-55" title="nc-bell-55"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-bold" title="nc-bold"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-book-bookmark" title="nc-book-bookmark"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-bookmark-2" title="nc-bookmark-2"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-box-2" title="nc-box-2"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-box" title="nc-box"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-briefcase-24" title="nc-briefcase-24"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-bulb-63" title="nc-bulb-63"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-bullet-list-67" title="nc-bullet-list-67"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-bus-front-12" title="nc-bus-front-12"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-button-pause" title="nc-button-pause"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-button-play" title="nc-button-play"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-button-power" title="nc-button-power"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-calendar-60" title="nc-calendar-60"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-camera-compact" title="nc-camera-compact"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-caps-small" title="nc-caps-small"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-cart-simple" title="nc-cart-simple"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-chart-bar-32" title="nc-chart-bar-32"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-chart-pie-36" title="nc-chart-pie-36"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-chat-33" title="nc-chat-33"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-check-2" title="nc-check-2"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-circle-10" title="nc-circle-10"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-cloud-download-93" title="nc-cloud-download-93"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-cloud-upload-94" title="nc-cloud-upload-94"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-compass-05" title="nc-compass-05"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-controller-modern" title="nc-controller-modern"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-credit-card" title="nc-credit-card"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-delivery-fast" title="nc-delivery-fast"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-diamond" title="nc-diamond"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-email-85" title="nc-email-85"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-favourite-28" title="nc-favourite-28"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-glasses-2" title="nc-glasses-2"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-globe-2" title="nc-globe-2"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-globe" title="nc-globe"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-hat-3" title="nc-hat-3"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-headphones" title="nc-headphones"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-html5" title="nc-html5"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-image" title="nc-image"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-istanbul" title="nc-istanbul"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-key-25" title="nc-key-25"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-laptop" title="nc-laptop"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-layout-11" title="nc-layout-11"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-lock-circle-open" title="nc-lock-circle-open"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-map-big" title="nc-map-big"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-minimal-down" title="nc-minimal-down"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-minimal-left" title="nc-minimal-left"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-minimal-right" title="nc-minimal-right"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-minimal-up" title="nc-minimal-up"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-mobile" title="nc-mobile"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-money-coins" title="nc-money-coins"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-note-03" title="nc-note-03"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-palette" title="nc-palette"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-paper" title="nc-paper"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-pin-3" title="nc-pin-3"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-planet" title="nc-planet"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-refresh-69" title="nc-refresh-69"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-ruler-pencil" title="nc-ruler-pencil"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-satisfied" title="nc-satisfied"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-scissors" title="nc-scissors"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-send" title="nc-send"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-settings-gear-65" title="nc-settings-gear-65"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-settings" title="nc-settings"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-share-66" title="nc-share-66"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-shop" title="nc-shop"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-simple-add" title="nc-simple-add"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-simple-delete" title="nc-simple-delete"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-simple-remove" title="nc-simple-remove"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-single-02" title="nc-single-02"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-single-copy-04" title="nc-single-copy-04"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-sound-wave" title="nc-sound-wave"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-spaceship" title="nc-spaceship"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-sun-fog-29" title="nc-sun-fog-29"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-support-17" title="nc-support-17"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-tablet-2" title="nc-tablet-2"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-tag-content" title="nc-tag-content"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-tap-01" title="nc-tap-01"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-tie-bow" title="nc-tie-bow"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-tile-56" title="nc-tile-56"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-time-alarm" title="nc-time-alarm"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-touch-id" title="nc-touch-id"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-trophy" title="nc-trophy"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-tv-2" title="nc-tv-2"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-umbrella-13" title="nc-umbrella-13"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-user-run" title="nc-user-run"/> </el-col>
</el-row>
<el-row gutter="10">
<el-col :md="6"> <stats-card icon="nc-icon nc-vector" title="nc-vector"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-watch-time" title="nc-watch-time"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-world-2" title="nc-world-2"/> </el-col>
<el-col :md="6"> <stats-card icon="nc-icon nc-zoom-split" title="nc-zoom-split"/> </el-col>
</el-row>
	</div>
</template>
<script>
import { StatsCard } from "@/components/dashboard/index";
export default {
  name: "IconsShowcase",
  components: {
    StatsCard,
  }
};
</script>
